module.exports = __webpack_public_path__ + "img/living3.50721ac1.png";